import { AxiosError, AxiosResponse } from "axios";
import protheusProvider from "../providers/protheus.provider";

export class MondayService {
  public async tasks(customer: string, project: string, user: string): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.get('WsRstApiMon/tasksUser', {
        params: {
          customer, //'000020',
          project, //'P09098',
          user,
          columnList: "IFN0YXR1cywgRGV0YWxoZSwgSG9yYXMgUmVhbA=="
          // columnList: 'Q1NNLCBSZXNwb25zw6F2ZWwsIFN0YXR1cywgRGV0YWxoZSwgSG9yYXMgUHJldmlzdGFzLCBIb3JhcyBSZWFsLCBUaW1lbGluZSwgRGVhZGxpbmUsIFByaW9yaWRhZGU='
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async updateTasksDescription(id: string, text: string, files: { fileName: string, fileData: string }[]): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.post('WsRstApiMon/update', {
        text,
        files
      }, {
        params: {
          id,
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async updateTasks(id: string, board: string, column_values: { title: string, value: string | number | object | [] }[]): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.post('WsRstApiMon/itemUpdate', {
        column_values
      }, {
        params: {
          id,
          board
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }
}